import { useState, useEffect } from "react";
import Modal from "../../../../utils/components/Modal";
import Input from "../../../../utils/components/Input";
import SelectBox from "../../../../utils/components/SelectBox";
import API from "../../../../utils/API";
import toastr from "toastr";
import { useParams } from "react-router";

const NewCompanyGroupModal = ({
  handleClose,
  selectedGroupId,
  users,
  roles,
  show,
  refreshData,
  project,
  translate,
}) => {
  const [name, setName] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [holdSubmitButton, setHoldSubmitButton] = useState(false);

  const { id: companyId } = useParams();

  useEffect(() => {
    setHoldSubmitButton(true);
  }, [show]);

  const getGroup = () => {
    let url = `groups/${selectedGroupId}?project_id=${project.id}`;
    API.getData(url).then(({ data: res }) => {
      setName(res.data.name);
      findRoleById(res.data.project_role.id);

      let selectedUsersList = res.data.users?.map((user) => ({
        value: user.id.toString(),
        label: user.name,
      }));

      setSelectedUsers(selectedUsersList);
      setSelectedRole({
        id: res.data?.project_role?.id,
        value: res.data?.project_role?.id,
        label: res.data?.project_role?.name,
      });
    });
  };

  const createGroup = () => {
    setHoldSubmitButton(false);
    const payload = {
      name: name,
      company_id: parseInt(companyId),
      project_role_id: selectedRole?.id,
      users: selectedUsers.map((user) => parseInt(user.value)),
    };

    API.postData(`groups?project_id=${project?.id}`, payload).then(() => {
      toastr.success(
        translate("company.add-group-modal.messages.created-successfully")
      );
      handleClose();
      refreshData();

      resetForm();
    });
  };

  const updateGroup = () => {
    setHoldSubmitButton(false);
    let url = "groups/" + selectedGroupId;
    const payload = {
      name,
      project_role_id: selectedRole.id,
      users: selectedUsers?.map((user) => parseInt(user.value)),
    };
    API.putData(url, payload).then(() => {
      toastr.success(
        translate("company.add-group-modal.messages.updated-successfully")
      );
      handleClose();
      refreshData();

      resetForm();
    });
  };

  const findRoleById = (roleId) => {
    let role = roles[roleId - 1];
    setSelectedRole(role);
  };

  const handleSubmit = () => {
    if (!name) {
      toastr.error(
        translate(
          "company.add-group-modal.messages.group-name-should-not-be-let-blank"
        )
      );
      setHoldSubmitButton(true);
      return;
    }
    if (selectedRole === null || selectedRole === undefined) {
      toastr.error(
        translate(
          "company.add-group-modal.messages.group-role-should-not-be-let-blank"
        )
      );
      setHoldSubmitButton(true);
      return;
    }

    if (selectedGroupId) {
      updateGroup();
    } else {
      createGroup();
    }
  };

  const resetForm = () => {
    setName("");
    setSelectedRole(null);
    setSelectedUsers([]);
  };

  useEffect(() => {
    if (selectedGroupId) {
      getGroup();
    } else {
      resetForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroupId]);

  return (
    <div>
      <Modal
        title={
          selectedGroupId
            ? translate("company.modal.edit-group")
            : translate("company.modal.create-group")
        }
        positiveButtonNode={translate("save")}
        negativeButtonNode={translate("cancel")}
        positiveButtonHandler={handleSubmit}
        negativeButtonHandler={() => {
          handleClose();
        }}
        setShow={(show) => {
          handleClose(show);
        }}
        modalSize="xl"
        show={show}
        disableButtons={!holdSubmitButton}
      >
        <div className="d-flex flex-wrap align-items-center">
          <div className="col-12 col-md-6 mt-4 pe-3">
            <Input
              type="text"
              title={translate("company.modal.group-name")}
              value={name}
              name="name"
              onChange={(e) => {
                setName(e.target.value);
              }}
              placeholder={translate(
                "company.modal.placeholders.enter-group-name"
              )}
            />
          </div>
          <div className="col-12 col-md-6 mt-4 pe-3">
            <label className="form-label fw-bold pb-0">
              {translate("company.modal.group-role")}{" "}
            </label>
            <SelectBox
              options={
                roles?.length
                  ? roles.map((role) => ({
                      id: role.id,
                      value: role.id,
                      label: role.name,
                    }))
                  : []
              }
              onChange={(value) => setSelectedRole(value)}
              height="36px"
              value={selectedRole}
            />
          </div>
          <div className="col-12 mt-4 pe-3">
            <p className="headTitle text-secondary fw-bold mb-1 ms-1">
              {translate("company.modal.users")}{" "}
            </p>
            <SelectBox
              options={users.map((user) => ({
                value: user.id.toString(),
                label: user.name,
              }))}
              value={selectedUsers}
              isMulti={true}
              onChange={(selectedUserList) => {
                setSelectedUsers(selectedUserList);
              }}
              placeholder={translate("company.modal.placeholders.select-users")}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default NewCompanyGroupModal;
